import { Card, CardHeader, CardPreview, makeStyles } from "@fluentui/react-components";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { SimpleStatistics } from "../../../library/CosmeWidgetAPIClient";
import { Bar } from "react-chartjs-2";
import PageLoading from "../../PageLoading";
import { ColorMap, NameDictionaly } from "../../../CosmeWidgetTheme";



const useStyles = makeStyles({
    card: {
        minWidth: "600px",
        minHeight: "150px",
        marginLeft: "1vw",
        marginRight: "1vw",
    },
    header: {
        paddingTop: "15px",
        fontSize: "150%",
        textAlign: "center",

    },
    title: {

    },
    value: {
        paddingTop: "15px",
        display: "block",
        fontSize: "400%",
        textAlign: "center",
    },
});


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
);

type BarChartBoardProp = {
    title: string;
    data: SimpleStatistics[];
    colorMap: ColorMap;
    nameDict: NameDictionaly;
}

const BarChartBoard = (prop: BarChartBoardProp) => {
    const styles = useStyles();
    if (prop.data !== undefined) {
        const legend: string[] = Array.from(
            new Set(prop.data
                .map((d: SimpleStatistics) => {
                    return d.legend;
                })));
        const labels: string[] = Array.from(
            new Set(prop.data
                .map((d: SimpleStatistics): Date => {
                    let day: Date;
                    if (d.date instanceof Date) {
                        day = d.date;
                    } else if (typeof d.date === "string") {
                        day = new Date(Date.parse(d.date));
                    } else {
                        day = new Date(Date.parse(d.date));
                    }
                    return day;
                })
                .sort((a, b) => { return a.getTime() - b.getTime() })
                .map((d: Date): string => {
                    return d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
                }))
        );
        console.log("labels = ", labels);

        const datasets = legend.map((l: string) => {
            return {
                label: (() => {
                    if (prop.nameDict[l] !== undefined) {
                        return prop.nameDict[l];
                    } else {
                        return l;
                    }
                })(),
                data: labels.map((d: string) => {

                    const found: SimpleStatistics | undefined = prop.data.find((s: SimpleStatistics) => {
                        let day: Date;
                        if (s.date instanceof Date) {
                            day = s.date;
                        } else if (typeof s.date === "string") {
                            day = new Date(Date.parse(s.date));
                        } else {
                            day = new Date(Date.parse(s.date));
                        }
                        let f: boolean = (d === day.getFullYear() + "/" + (day.getMonth() + 1) + "/" + day.getDate() && s.legend === l);
                        return f;
                    });
                    if (found === undefined) {
                        return 0;
                    } else {
                        return found.count;
                    }

                }),
                backgroundColor: (() => {
                    if (prop.colorMap[l] !== undefined) {
                        return prop.colorMap[l];
                    } else {
                        return "#CCCCCC";
                    }
                })(),
            }
        });
        const data = {
            labels,
            datasets: datasets,
        };
        console.log("data = ", data);
        const barChartOptions = {
            plugins: {
                title: {
                    display: false,
                    text: prop.title,
                },
                legend: {
                    display: true,
                },
                tooltip: {
                    callbacks: {

                    }
                }
            },

            responsive: true,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
        }
        return (
            <Card className={styles.card}>
                <CardHeader
                    className={styles.header}
                    header={prop.title}
                >
                </CardHeader>
                <CardPreview
                    className={styles.value}
                >
                    <Bar
                        options={barChartOptions}
                        data={data}
                    ></Bar>
                </CardPreview>
            </Card>
        );
    }


    return <>
        <Card className={styles.card}>
            <CardHeader
                className={styles.header}
                header={prop.title}
            >
            </CardHeader>
            <CardPreview
                className={styles.value}
            >
                <PageLoading
                    message={prop.title}
                ></PageLoading>
            </CardPreview>
        </Card>
    </>

}

export default BarChartBoard;